(function ($, $win) {
  function EndlessScroller(options) {
    this.options = $.extend({
      scrollable: document.documentElement,
      triggerHeight: 500,
      spinner: jQuery('.endless-scrolling-pagination .spinner'),
      loadMore: jQuery('.endless-scrolling-pagination .load-more-button'),
      loadPageHandler(page) {
        this.onLoadingFinish(page, true);
      },
    }, options);

    this.options.scrollable = jQuery(this.options.scrollable).get(0);

    this.lastPage = 0;
    this.isLoading = false;
    this.isFinalPage = false;

    this.init();
  }

  EndlessScroller.prototype.init = function () {
    const self = this;

    let scrollableListener = self.options.scrollable;
    if (scrollableListener === document.documentElement) {
      scrollableListener = window;
    }

    jQuery(scrollableListener).on('scroll', (e) => {
      self.checkScrollingPosition();
    });
    self.options.loadMore.on('click', (e) => {
      self.loadNextPage();
    });
  };

  EndlessScroller.prototype.checkScrollingPosition = function () {
    if (!this.isFinalPage && !this.isLoading
            && this.options.scrollable.scrollTop >= (this.options.scrollable.scrollHeight - this.options.scrollable.clientHeight - this.options.triggerHeight)) {
      this.loadNextPage();
    }
  };

  EndlessScroller.prototype.loadPage = function (page) {
    this.onLoadingStart(page);
    this.options.loadPageHandler.call(this, page);
  };

  EndlessScroller.prototype.loadNextPage = function () {
    this.loadPage(this.lastPage + 1);
  };

  EndlessScroller.prototype.onLoadingStart = function (page) {
    this.isLoading = true;
    this.options.spinner.show();
    this.options.loadMore.hide();
  };

  EndlessScroller.prototype.onLoadingFinish = function (page, isFinalPage) {
    this.isLoading = false;
    this.lastPage = page;
    this.isFinalPage = !!isFinalPage;

    this.options.spinner.hide();

    if (this.isFinalPage) {
      this.options.loadMore.hide();
    } else {
      this.options.loadMore.show();
    }

    this.checkScrollingPosition();
  };

  EndlessScroller.prototype.onLoadingFail = function (page) {
    this.isLoading = false;
    this.options.spinner.hide();
    this.options.loadMore.show();
  };

  window.EndlessScroller = EndlessScroller;
}(jQuery, jQuery(window)));
